import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=5c8fe333&scoped=true&"
import script from "./finance.vue?vue&type=script&lang=js&"
export * from "./finance.vue?vue&type=script&lang=js&"
import style0 from "./finance.vue?vue&type=style&index=0&id=5c8fe333&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8fe333",
  null
  
)

export default component.exports